import React from "react";
import Icon from "../icons/Icon";

// titleTag existe porque o vazio dentro de uma tabela é um parágrafo — o <h1>
// da página é o título dela —, mas na tela de 404, que não tem outro título, o
// mesmo bloco precisa ser o cabeçalho da página.
function EmptyState({ icon, title, help, action, titleTag: Title = "p" }) {
  return (
    <div className="card-state">
      {icon && (
        <div className="empty-icon">
          <Icon name={icon} strokeWidth={1.5} />
        </div>
      )}
      <Title className="empty-title">{title}</Title>
      {help && <p className="empty-help">{help}</p>}
      {action}
    </div>
  );
}

export default EmptyState;
